import { useState } from 'react';
import { PhieuNhapKho } from '@/types/schemas/phieu-nhap-kho.type';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const usePhieuNhapKhoExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportPhieuNhapKhoExcel, exportPhieuNhapKhoFromApi } = await import('../utils/excel-export');
      if (entity?.slug) {
        await exportPhieuNhapKhoFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportPhieuNhapKhoExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
